/**
 * App Type Detection Utility
 *
 * Determines whether the application is running as a Teams app or standalone web app.
 * This is controlled by the VITE_APP_TYPE environment variable set during build.
 */

/**
 * Type definition for supported application types
 */
export type AppType = 'web' | 'teams';

/**
 * Gets the current application type from environment variables
 * @returns The application type, defaults to 'web' if not specified
 */
export function getAppType(): AppType {
  const appType = import.meta.env.VITE_APP_TYPE as string | undefined;

  if (appType === 'teams') {
    return 'teams';
  }

  return 'web';
}

/**
 * Checks if the application is running in Microsoft Teams
 * @returns true if running as a Teams app, false otherwise
 */
export function isTeamsApp(): boolean {
  return getAppType() === 'teams';
}

/**
 * Checks if the application is running as a standalone web app
 * @returns true if running as a web app, false otherwise
 */
export function isWebApp(): boolean {
  return getAppType() === 'web';
}
